






import { Vue, Component, Watch, Prop } from "vue-property-decorator";

@Component({
  name: "uc-notifications"
})
export default class UcNotificationsComponent extends Vue {
  @Prop({ type: Number, default: 0 })
  num: Number;
  @Prop({default:String})
  icon:String
  
  iconClass= this.icon;
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./scripts/views/layouts/header/uc-notifications.vue